import { Component, Input } from '@angular/core';
import { UserService } from 'src/app/core/user.service';

@Component({
  selector: 'app-weekly-goal-widget',
  templateUrl: './weekly-goal-widget.component.html',
  styleUrls: ['./weekly-goal-widget.component.scss'],
  standalone: false
})
export class WeeklyGoalWidgetComponent {

  @Input() showButtonToSmartRepetition: boolean = false;

  cardsRepeatedCount: number | undefined;
  goalCount: number | undefined;

  constructor(
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.userService.getWeeklyGoalCount().subscribe((res: any) => {
      this.cardsRepeatedCount = res.cardsRepeatedCount;
      this.goalCount = res.goalCount;
    });
  }

  goToSmartRepetition() {
    window.location.href = '/smart-repetition';
  }
}
